var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1401_18898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.29883 16.5173C7.62391 17.1234 8.26358 17.5357 8.99951 17.5357C9.73545 17.5357 10.3751 17.1234 10.7002 16.5173",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48002 2.9223C6.41353 1.9888 7.67963 1.46436 8.99982 1.46436C10.32 1.46436 11.5861 1.9888 12.5196 2.9223C13.4531 3.85581 13.9776 5.12192 13.9776 6.4421C13.9776 7.21888 14.1057 7.94878 14.2986 8.69535C14.3526 8.86436 14.4121 9.02384 14.4762 9.1743C14.7744 9.876 15.5958 10.1154 16.2087 10.5691C17.1234 11.2463 16.9465 12.6954 16.1856 13.258C16.1856 13.258 14.9571 14.3215 8.99982 14.3215C3.04241 14.3215 1.81393 13.258 1.81393 13.258C1.05307 12.6954 0.876216 11.2463 1.79097 10.5691C2.40381 10.1154 3.22512 9.87605 3.5235 9.17436C3.82091 8.47493 4.02207 7.5802 4.02207 6.4421C4.02207 5.12192 4.54651 3.85581 5.48002 2.9223Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1401_18898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.d0c40d2134e97187987116dc261153a8.svg";
export { ForwardRef as ReactComponent };